export default __webpack_public_path__ + "static/media/icon2.ae5cd738.svg";